import { render, staticRenderFns } from "./zuzhi-tree.vue?vue&type=template&id=6c6a40ac&scoped=true"
import script from "./zuzhi-tree.vue?vue&type=script&lang=ts"
export * from "./zuzhi-tree.vue?vue&type=script&lang=ts"
import style0 from "./zuzhi-tree.vue?vue&type=style&index=0&id=6c6a40ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a40ac",
  null
  
)

export default component.exports